export default __webpack_public_path__ + "static/media/p11.62c434b2.jpg";